interface IRegexSerialized {
    pattern: string;
    flags: string;
    lastIndex?: number;
}

function _isRegexSerialized(object: unknown): object is IRegexSerialized {
    const isNullOrUndefined = (value: unknown): boolean => value === null || value === undefined;

    if (isNullOrUndefined(object) || typeof object !== 'object') {
        return false;
    }

    const record = object as Partial<IRegexSerialized>;

    return !isNullOrUndefined(record.pattern) && !isNullOrUndefined(record.flags);
}

function _serialize(regex: RegExp): IRegexSerialized {
    const state: IRegexSerialized = {
        pattern: regex.source,
        /* Always unicode */
        flags: `u${regex.global ? 'g' : ''}${regex.ignoreCase ? 'i' : ''}${
            regex.multiline ? 'm' : ''
        }`,
    };

    if (regex.lastIndex !== 0) {
        state.lastIndex = regex.lastIndex;
    }

    return state;
}

function _expand(state: IRegexSerialized): RegExp {
    const regExp = new RegExp(state.pattern, state.flags);
    regExp.lastIndex = state.lastIndex ?? 0;
    return regExp;
}

/* Stages (encode)
  1. Construct IRegexSerialized object representing RegExp 
  2. Use JSON.stringify to convert from IRegexSerialized to string
  3. use encodeURI to ensure any unicode sequences will be preserved 
*/
function stringify(regex: RegExp): string {
    return encodeURI(JSON.stringify(_serialize(regex)));
}

function parse(regex: string): RegExp {
    const result = JSON.parse(decodeURI(regex)) as unknown;

    if (!_isRegexSerialized(result)) {
        throw new Error(`Unexpected parsing of non-regex string: ${regex}`);
    }

    return _expand(result);
}

export default Object.freeze({
    stringify,
    parse,
});
